
import { Watch, Component, Vue, toNative, mixins } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'
import GroupSelect from "./com/group-select.vue";
import SimpleSkuDetail from "./com/simple-sku-detail.vue";
import EditName from "./com/edit-name.vue";
import EditUnit from "./com/edit-unit.vue";
import ChangeSort from "./com/change-sort.vue";
@Component({
  components: { GroupSelect, SimpleSkuDetail, ChangeSort },
})
export default class extends mixins(ListViewVue) {
  listType = "router";

  /** image 是数组，取第一张当封面；历史数据可能是字符串，两种都兜一下 */
  goodsImage(row) {
    let image = row.image;
    if (Array.isArray(image)) return image[0] || '';
    return image || '';
  }

  tableChange(type) {
    let data = { ...this.condition };
    data.type = type;
    this.find(data);
  }

  /**
   * 改名称和改单位各走一个弹层，都不走 operat 那个整单保存。
   * 两个弹层都打 base-operat，只发自己那个字段 —— 后端是「传了哪个改哪个」，
   * 所以互不覆盖。
   */
  async editName(row) {
    try {
      await this.$dialog({
        title: "编辑商品名称",
        props: {
          width: "440px",
        },
        content: () => {
          return <EditName item={row}></EditName>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("修改成功");
    this.refresh();
  }

  async editUnit(row) {
    try {
      await this.$dialog({
        title: "编辑商品单位",
        props: {
          width: "440px",
        },
        content: () => {
          return <EditUnit item={row}></EditUnit>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("修改成功");
    this.refresh();
  }

  operatGoods(id?) {
    if (id) {
      return this.$goto({
        name: "goods-edit",
        query: {
          id,
        },
      });
    }
    return this.$goto({
      name: "goods-edit",
    });
  }
  async getList() {
    return this.$post("/manager/goods/list", {
      ...this.mesureData,
      categoryId: (() => {
        if (!this.mesureData.categoryId) return
        return this.mesureData.categoryId instanceof Array ? this.mesureData.categoryId : [this.mesureData.categoryId]
      })()
    });
  }
  resetFilter() {
    this.find({ ...this.getCondition(), type: this.condition.type });
  }
  async deleteRow(id) {
    let { error, message } = await this.$post("/manager/goods/delete", { id });
    if (error) return this.$error(message);
    this.$success("删除成功");
    this.refresh();
  }
  cloneGoods(id) {
    this.$goto({
      name: "goods-edit",
      query: {
        type: "clone",
        id,
      },
    });
  }
}

